import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nr-tag--text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrIcon = _resolveComponent("NrIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classNames)
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString($props.label), 1),
    ($props.icon && $props.clickable && !$props.badge)
      ? (_openBlock(), _createBlock(_component_NrIconButton, {
          key: 0,
          variant: "minimal-neutral",
          icon: { name: $props.icon, type: $props.iconType },
          size: "small",
          "aria-label": $props.ariaLabel,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-click')))
        }, null, 8, ["icon", "aria-label"]))
      : _createCommentVNode("", true),
    ($props.icon && !$props.clickable && !$props.badge)
      ? (_openBlock(), _createBlock(_component_NrIcon, {
          key: 1,
          name: $props.icon,
          iconType: $props.iconType
        }, null, 8, ["name", "iconType"]))
      : _createCommentVNode("", true)
  ], 2))
}